import React, { Component } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import CatGrid from '../CatGrid';
import CatPanel from '../CatPanel';

function OutcomePane(props) {
  const catAdded = (cat)=>{props.catAdded(cat)};
  const catChanged = (cat)=>{props.catChanged(cat)};
  const catDeleted = (cat)=>{props.catDeleted(cat)};
  const openPage = (cat)=>{props.selectionChanged(cat);
  }

  return(
  <React.Fragment>
  <CatPanel cat={props.cat} openPage={openPage}/>
  <TabView>
  </TabView>
  </React.Fragment>
	)
}

export default OutcomePane;
